const UPDATE_DOC =
  'https://docs.google.com/document/d/1pnXF7E8kxxE_eRNcKVyQW6QisMicH8QOqkTrAplCTjs/edit?usp=sharing';
const SLACK = 'https://draftfast.herokuapp.com/';
const TWITTER = '';
const TWITCH = '';

export { UPDATE_DOC, SLACK, TWITTER, TWITCH };



// WEBPACK FOOTER //
// ./src/services/links.js